/** Typed access to the web app's environment variables. */
export const ENV = {
	API_URL: import.meta.env.VITE_API_URL,
	STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
	ORIGIN: import.meta.env.VITE_ORIGIN,
	GTM_ID: import.meta.env.VITE_GTM_ID,
	PAYPAL_CLIENT_ID: import.meta.env.VITE_PAYPAL_CLIENT_ID as string | undefined
} as const

/**
 * True solo en el despliegue REAL de producción: un build de producción servido
 * en la raíz (`/`). Un preview también es un build de producción (`import.meta.env.PROD`),
 * pero se sirve bajo subruta (`/previews/<rama>/`), por lo que debe tratarse como
 * NO producción → llaves/precios/cupones de prueba de Stripe y sin enviar analíticas.
 */
export const isProduction = (): boolean => import.meta.env.PROD && import.meta.env.BASE_URL === "/"
